import * as googleUrls from '$extensionSrc/automations/google/googleUrls'
import { updatePlatformUserAccountData } from '$extensionSrc/data/platform/platformUserAccountData'
import { StageType } from '$extensionSrc/utils/enums'

import { GOOGLE_AUTOMATION_STAGE_STATUSES } from './googleAutomationStageStatuses'

export const googleSetAccountData = [
  {
    type: StageType.ACTION,
    key: 'SET_ACCOUNT_DATA',
    status: GOOGLE_AUTOMATION_STAGE_STATUSES.INITIALIZING_PLAYBOOK,
    action: async (machineContext, userContext) => {
      const { googleAccountIndex, userId } = userContext
      googleUrls.homeUrl.navigateForUser(googleAccountIndex)

      const { machineName: platform } = machineContext

      if (!userId) {
        return
      }

      return updatePlatformUserAccountData(platform, userId, {})
    },
  },
]

export function isAccountDataGathered(accountData: any): boolean {
  return Boolean(accountData) && !accountData?.isDeleted
}
